import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import {
  Container, Logo, MessageContainer, Title, Text, DescriptionContainer,
} from './styles';
import { formatScheduleDate } from '../../../../core/utils/format-date';

const TestSessionNotStarted = (props) => {
  const { testSession } = props;
  // guess as default, because of this PR / logic
  // https://github.com/PlaybookUX/playbook-web/pull/1976
  const timezone = moment.tz.guess() || testSession.timeZone;

  return (
    <Container>
      <MessageContainer>
        <Logo src="/images/playbook-logo.png" alt="Playbook" />

        <DescriptionContainer>
          <Title>The session has not started</Title>
          <Text brspace={+true}>Once the moderator joins the meeting, the livestream will start.</Text>
          <Text>
            {`Participant: ${testSession.firstName}`}
          </Text>
          <Text>
            {`Date & Time: ${formatScheduleDate(testSession.startAt, timezone)}`}
          </Text>
        </DescriptionContainer>
      </MessageContainer>
    </Container>
  );
};

TestSessionNotStarted.propTypes = {
  testSession: PropTypes.shape({
    startAt: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    timeZone: PropTypes.string.isRequired,
  }).isRequired,
};

export default TestSessionNotStarted;
